import { alpha } from '@mui/material/styles'

/** @param {import('@mui/material').Theme} theme */
export function getMenuItemSx(theme, { showIconColumn, isDisabled, isDanger, isSelected }) {
  return {
    boxSizing: 'border-box',
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    alignSelf: 'stretch',
    width: '100%',
    minWidth: 'fit-content',
    maxWidth: 'none',
    height: 'fit-content',
    minHeight: 'fit-content',
    padding: '4px 4px',
    ...(!showIconColumn ? { paddingLeft: '10px', paddingRight: '10px' } : {}),
    gap: '6px',
    borderRadius: '6px',
    ...(isDisabled
      ? {
          opacity: 0.45,
          color: theme.palette.text.disabled,
          cursor: 'default',
          pointerEvents: 'none',
          '&:hover': { backgroundColor: 'transparent' },
        }
      : isDanger
        ? {
            color: theme.palette.error.main,
            backgroundColor: alpha(theme.palette.error.main, 0.08),
            '&:hover': { backgroundColor: alpha(theme.palette.error.main, 0.14) },
          }
        : isSelected
          ? {
              color: theme.palette.text.primary,
              backgroundColor: theme.palette.action.selected,
              '&:hover': { backgroundColor: theme.palette.action.selected },
            }
          : {
              color: theme.palette.text.secondary,
              '&:hover': { backgroundColor: 'var(--app-bg-hover)' },
            }),
  }
}
